import { NumberFormatType } from "@/core/types";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import { DateService, NumberFormatterService } from "@/core/services";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";

export interface FormatOptions {
  dateFormat?: string;
  numberFormat?: NumberFormatType;
}

export abstract class AddChargebreakdownItemCommon {
  private readonly dateFormat: string = "MM/DD/YYYY";
  private readonly numberFormat: NumberFormatType = "integer";

  constructor(formatOptions?: FormatOptions) {
    this.dateFormat = formatOptions?.dateFormat ?? this.dateFormat;
    this.numberFormat = formatOptions?.numberFormat ?? this.numberFormat;
  }

  public formatDate(date: string, format: string = this.dateFormat) {
    return new DateService(new DateAdapter()).format(date, format);
  }

  public formatNumber(number: number, format: NumberFormatType = this.numberFormat) {
    return new NumberFormatterService(new NumberFormatterAdapter()).format(number, format);
  }
}
